<template>
    <template v-if="native">
        <!-- HTML Native Image -->
        <NuxtImg
            v-if="blok.image?.filename"
            :src="blok.image?.filename"
            :title="blok?.image.title"
            :alt="blok?.image.alt"
            :width="width"
            :height="height"
            provider="storyblok"
            format="webp"
            loading="lazy"
        />
    </template>

    <template v-else>
        <!-- CSS Background -->
        <div
            class="image"
            :class="blok?.bgSize"
            :style="[optimizedImage, { 'background-position': blok?.bgPosition }]"
        ></div>
    </template>
</template>

<script setup lang="ts">
const { blok } = defineProps({
    blok: { type: Object, default: null },
    native: { type: Boolean, default: true },
    width: { type: Number, default: 250 },
    height: { type: Number, default: null },
});

const img = useImage();

const optimizedImage = computed(() => {
    const imgUrl = img(blok.image.filename, { format: 'webp', height: 100 }, { provider: 'storyblok' });
    return { backgroundImage: `url('${imgUrl}')` };
});
</script>
